import React from "react"
import { Link } from "gatsby"
import ContactForm from "./forms/ContactForm"
import CourseForm from "./forms/CourseForm"

import './ContactBox.scss'

const FormData = {
  principal: {
    name: 'principal',
    description: `Recibe ayuda de nuestros expertos en analítica o cotiza el licenciamiento que necesitas, un especialista te contactará.`,
    form: <ContactForm/>
  },
  courses: {
    name: 'courses',
    description: `Compártenos tus datos y nosotros nos pondremos en contacto.`,
    form: <CourseForm/>
  }
}

const ContactBox = ({ section, children }) => {
  let formData = FormData[section] || FormData.principal

  return (
    <section id="contactus">
      <div className={['content', formData.name].join(' ')}>
        <div className="principal-content navigationbar-space">
          <div className="form">
            <div className="text">
              <div>
                <h2>¿Quieres saber más?</h2>
                <p>{formData.description}</p>
              </div>
              <div className="bottom">
                <h3>Te podemos ayudar en más</h3>
                <Link to="/support">Levantar un ticket de soporte</Link>
                <Link to="/careers">Únete al equipo</Link>
              </div>
            </div>
            <div className="card">
              { children ? children : formData.form }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactBox